import { cardSchema, type Card } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postRestore = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/cards/${id}/restore`, { method: 'POST' });

export const restoreCard = async (id: string): Promise<Card> =>
  cardSchema.parse(await postRestore(id));
